/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampaignLeadsResponseApiModel } from '../../models/campaign-leads-response-api-model';

export interface RetrieveCampaignLeads$Params {
  id: string;
}

export function retrieveCampaignLeads(http: HttpClient, rootUrl: string, params: RetrieveCampaignLeads$Params, context?: HttpContext): Observable<StrictHttpResponse<CampaignLeadsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, retrieveCampaignLeads.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampaignLeadsResponseApiModel>;
    })
  );
}

retrieveCampaignLeads.PATH = '/campaigns/{id}/leads';
